<template>
  <div v-if="getUser.username=='Guest'">
    <a class="text-right" dark @click.stop="toggleDrawer()">
      <v-icon>mdi-menu</v-icon>
    </a>
    <v-navigation-drawer width="100%" v-if="this.getUser" v-model="drawer" fixed :app="true" absolute temporary>
      <v-container text-left px-0 mx-5>
       <v-row  class="text-right" >
          <v-col cols=11>
            <v-btn color="red darken-3" text @click="setDrawer(false)">
                <i style="font-size:3rem" class="big mdi mdi-close"></i>
            </v-btn>
          </v-col>
       </v-row>
        <v-row class="px-0" text-left>
          <v-col cols=8>
            <changeLocaleBtn :btnColor="'primary'" />
          </v-col>
        </v-row>
        <v-row class="px-0" text-left>
          <v-col cols=8>
            <bookmark :btnColor="'primary'" />
          </v-col>
        </v-row>
        
        <v-row class="pb-3" v-for="item in guestPages" :key="item.title" text-center>
          <v-col cols=12>
            <div v-if="$route.name==item.name">
                <v-btn  class="currentPage" text
                  :disabled="true" @click="gotopage(item.name,item.params)"> {{ $t(item.title) }}</v-btn>
            </div>
            <div v-else>
              <v-btn text :disabled="item.disabled==='true'?true:item.disabled=='false'?false:item.disabled" @click="gotopage(item.name,item.params)"> {{ $t(item.title) }}
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-row align="center" justify="center">
          <v-col cols=12>
            <v-btn text v-if="logged!=''" @click="logout()" color="primary"> {{ $t('Logout') }}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
  </div>
  <div v-else>
    <a class="text-right" dark @click.stop="toggleDrawer">
      <v-icon>mdi-menu</v-icon>
    </a>
    <v-navigation-drawer width="100%" v-if="this.getUser" v-model="drawer" fixed :app="true" absolute temporary>
      <v-container text-left px-0 mx-5>

       <v-row  class="text-right" >
          <v-col cols=11>
            <v-btn color="red darken-3" text @click="setDrawer(false)">
                <i style="font-size:3rem" class="big mdi mdi-close"></i>
            </v-btn>
          </v-col>
       </v-row>
      <v-row v-if="isDeviceIosOrUnableToLunchAR" align="center" justify="center">
          <v-col cols=12>
            <label  class="error" color="error">{{$t('DontUseiOs')}}</label>
          </v-col>
        </v-row>
        <v-row class="px-0" text-left>
          <v-col cols=8>
            <changeLocaleBtn :btnColor="''" />
          </v-col>
        </v-row>
        <v-row class="px-0" text-left>
          <v-col cols=8>
            <bookmark :btnColor="'primary'" />
          </v-col>
        </v-row>
        <v-row class="pb-3" v-for="item in authorPages" :key="item.title" text-center>
          <v-col cols=12>
            <div v-if="$route.name==item.name">
                <v-btn  class="currentPage" text
                  :disabled="true" @click="gotopage(item.name,item.params)"> {{ $t(item.title) }}</v-btn>
            </div>
            <div v-else>
                <v-btn text :disabled="item.disabled==='true'?true:item.disabled=='false'?false:item.disabled" @click="gotopage(item.name,item.params)"> {{ $t(item.title) }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col cols=12>
            <v-btn text v-if="logged!=''" @click="logout()" color="error"> {{ $t('Logout') }}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
  </div>
</template>

<script>

import bookmark from "@/components/bookmark.vue"
import changeLocaleBtn from "@/components/changeLanguageBtn.vue"
    export default {
  name: 'mobilenavbar',
  components: {
    changeLocaleBtn,
    bookmark
  },

  data () {
  return {
    //state of the navigation menu window
//all navigable and non-navigable menu pages
        authorPages: [
          { title: 'createstory', name: 'createNewStoryContent', params:{},icon: 'mdi-plus-circle', disabled:process.env.VUE_APP_READONLY},
          { title: 'viewStories', name: 'home',icon: 'mdi-account', params:{tab:1}, disabled:false},
          { title: 'settings', name: 'settings',icon: 'mdi-cog', params:{}, disabled:true},
          { title: 'privacyPolices', name: 'privacyPolices',icon: 'mdi-alert', params:{}, disabled:true},
          { title: 'aboutMemex', name: 'aboutMemex',icon: 'mdi-alert', params:{}, disabled:true}
        ],
        guestPages: [
          { title: 'viewStories', name: 'home',icon: 'mdi-account', params:{tab:1}, disabled:false},
          { title: 'loginAuthor', name: 'login',icon: 'mdi-alert', params:{}, disabled:false},
          { title: 'settings', name: 'settings',icon: 'mdi-cog', params:{}, disabled:true},
          { title: 'privacyPolices', name: 'privacyPolices',icon: 'mdi-alert', params:{}, disabled:true},
          { title: 'aboutMemex', name: 'aboutMemex',icon: 'mdi-alert', params:{}, disabled:true}
        ],
      }
  },
  mounted(){
    this.$store.dispatch("setIsdrawerOpen", false)
  },
  computed: {
    isDeviceIosOrUnableToLunchAR: {
      get: function () {
        if(this.$device.ios)
        return true
        return false
      }
    },
    drawer: {
      get: function () {
        return this.$store.getters.getIsdrawerOpen;
      },
      set: function () {
      }
    },
    logged: {
      get: function () {
        return this.$store.getters.getAccessToken;
      }
    },
    getUser: {
      get: function () {
        return this.$store.getters.getUser;
      }
    },
    getcurrenUserStoryFilter: {
      get: function () {
        return this.$store.getters.getcurrenUserStoryFilter;
      }
    },
  },

methods: {
  setDrawer(value){
      this.$store.dispatch("setIsdrawerOpen", value)
  },
  toggleDrawer(){
      this.$store.dispatch("setIsdrawerOpen", !this.drawer)
  },

  //avoid error messages if I try to go the same route
  //change page
    gotopage: function (page,params) {
        if (page=='createNewStoryContent'){
          //reset new stories and push
        const defaultCache={isStoryID:null,checkboxPublic:false,storyTitle:"",content:"", imageFileRaw:null,imageFile:null,imageType:"image/jpeg",audioFiles:[],audioFilesRaw:[],audioTypes:[],audioFileTitles:[],videoFileRaw:null,videoFile:null,videoType:"video/mp4"}
        this.$store.dispatch("setNewStories", defaultCache).then(()=>{
          if(this.$router.currentRoute.name!=page)
            this.$router.push({'name':page,'params':params})
        })

        }
        else {
          if(this.$router.currentRoute.name!=page){
            this.$router.push({'name':page,'params':params})
          }
        }
    },
    logout: function() {
      this.$store
        .dispatch("logout", null).then(()=> this.$router.push({'name':"splashScreen"}))
    }
}
};
</script>
<style >
.currentPage{
  border-bottom:1px solid primary;
}
.logout{
  color: primary;
}
.userstyle{
  font-size: 1.2rem;
}
.backgroundgrey{
  background-color: lightgrey;
}
</style>